// Style Imports
import Styles from './FileTree.module.scss';

// Component Imports
import { getFileIcon } from '../../filetypemapping';
import { IconButton } from "@mui/material";

const FileTree = ({ fileTree, onFolderExpand, onFileClick, expandedFolders, selectedItem, rootFolder, onContextMenu }) => {

    return (
        <div id='fileTreeContainer' className={Styles.fileTreeContainer}>
            {fileTree.map((file, index) => (
                <div id='fileItem' key={index} className={Styles.fileItem}>
                    {file.type === "folder" ? (
                        <span
                            id={`item-${file.name}`}
                            onClick={() => {
                                onFolderExpand(file)
                            }}
                            className={Styles.itemContent}
                            style={{
                                backgroundColor: selectedItem?.path === file?.path ? '#165bb6' : '',
                                color: selectedItem?.path === file?.path ? '#ffffff' : '',
                                transition: 'background-color 0.2s ease, color 0.2s ease',
                            }}
                            onContextMenu={(e) => onContextMenu(e, file)}
                        >
                            <IconButton size="small" sx={{ color: selectedItem?.path === file?.path ? '#ffffff' : '' }}>
                                {expandedFolders.has(file.path) ? getFileIcon('folderopen') : getFileIcon('folderclosed')}
                            </IconButton>
                            <span title={file.name} className={Styles.itemName}>{file.name}</span>
                        </span>
                    ) : (
                        <span
                            id={`item-${file.name}`}
                            onClick={() => onFileClick(file)}
                            className={Styles.itemContent}
                            style={{
                                backgroundColor: selectedItem?.path === file?.path ? '#165bb6' : '',
                                color: selectedItem?.path === file?.path ? '#ffffff' : '',
                                transition: 'background-color 0.2s ease, color 0.2s ease',
                            }}
                            onContextMenu={(e) => onContextMenu(e, file)}
                        >
                            <IconButton size="small">
                                {getFileIcon(file.name)}
                            </IconButton>
                            <span title={file.name} className={Styles.itemName}>{file.name}</span>
                        </span>
                    )}
                    {/* Render children recursively if they exist */}
                    {file.type === "folder" && file.children && expandedFolders.has(file.path) && (
                        <FileTree
                            fileTree={file.children}
                            onFolderExpand={onFolderExpand}
                            onFileClick={onFileClick}
                            expandedFolders={expandedFolders}
                            selectedItem={selectedItem}
                            rootFolder={rootFolder}
                            onContextMenu={onContextMenu}
                        />
                    )}
                </div>
            ))
            }
        </div >
    );
}

export default FileTree;
